// utils/fieldMapper.js
export const generateDisplayFields = (fields) => {
  return fields.map((field) => {
    const isImage = field.type === "image";
    return {
      Header: field.label,
      accessor: field.label, // Display name for DataTable
      dataKey: field.name,   // Key from API data
      isImage,
      ...(isImage && {          // Only add width & height if it's an image
        width: field.width || 50,    // default 50px
        height: field.height || 50,  // default 50px
      }),
    };
  });
};
